export enum SellerType {
  LegalEntity = "LegalEntity",
  Individual = "Individual",
}
